"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var v4_1 = __importDefault(require("uuid/v4"));

var remote_exec_1 = require("./remote-exec");

var bit_utils_events_observer_1 = __importDefault(require("@bit/bit.utils.events.observer"));

var socket_io_client_1 = __importDefault(require("socket.io-client"));

var config = {
  renderUrl: "http://localhost:3000",
  orchestratorUrl: "http://capsule.dev.bit.dev"
};
var CapsuleType;

(function (CapsuleType) {
  CapsuleType["react"] = "ReactCapsule";
  CapsuleType["vue"] = "VueCapsule";
  CapsuleType["angular"] = "AngularCapsule";
  CapsuleType["node"] = "NodeCapsule";
  CapsuleType["react_native"] = "ReactNativeCapsule";
})(CapsuleType = exports.CapsuleType || (exports.CapsuleType = {}));

var Lifecycle;

(function (Lifecycle) {
  Lifecycle["Reconnecting"] = "reconnecting";
  Lifecycle["Connected"] = "connected";
  Lifecycle["Disconnected"] = "disconnected";
  Lifecycle["Idle"] = "idle";
  Lifecycle["Connecting"] = "connecting";
})(Lifecycle = exports.Lifecycle || (exports.Lifecycle = {}));

var RemoteContainer = function () {
  function RemoteContainer(remoteOptions) {
    var _this = this;

    this.connected = false;
    this._state = Lifecycle.Disconnected;
    this.idle = false;
    this.lastUsed = Date.now();
    this.idleInterval = setInterval(function () {
      return __awaiter(_this, void 0, void 0, function () {
        var time, now;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              time = this.lastUsed + 180 * 1000;
              now = Date.now();
              if (!(time < now && !this.idle && this.socket.connected)) return [3, 2];
              this.idle = true;
              return [4, this.destroy()];

            case 1:
              _a.sent();

              this.observer.emit(Lifecycle.Idle);
              _a.label = 2;

            case 2:
              return [2];
          }
        });
      });
    }, 1000);
    var defaultSocketOptions = {
      uri: 'https://capsule.bit.dev',
      autoConnect: false,
      secure: true,
      reconnect: true,
      rejectUnauthorized: false,
      transports: ['websocket']
    };

    var _a = remoteOptions || {},
        _b = _a.observer,
        observer = _b === void 0 ? new bit_utils_events_observer_1.default() : _b,
        _c = _a.capsuleType,
        capsuleType = _c === void 0 ? CapsuleType.react : _c,
        _d = _a.socketOptions,
        socketOptions = _d === void 0 ? {
      uri: 'https://capsule.bit.dev',
      autoConnect: false,
      secure: true,
      reconnect: true,
      rejectUnauthorized: false
    } : _d;

    this.socket = socket_io_client_1.default(socketOptions.uri, Object.assign({}, defaultSocketOptions, socketOptions, {
      query: "token=" + remoteOptions.token + "&cookie=" + remoteOptions.cookie
    }));
    this.capsuleType = capsuleType;
    this.bitId = remoteOptions.bitId;
    this.observer = observer;
  }

  RemoteContainer.prototype.stats = function () {
    throw new Error("Method not implemented.");
  };

  RemoteContainer.prototype.commit = function (options) {
    throw new Error("Method not implemented.");
  };

  RemoteContainer.prototype.top = function (psArgs) {
    throw new Error("Method not implemented.");
  };

  Object.defineProperty(RemoteContainer.prototype, "id", {
    get: function get() {
      return this.socket.id;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RemoteContainer.prototype, "url", {
    get: function get() {
      return this._url;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RemoteContainer.prototype, "state", {
    get: function get() {
      return this._state;
    },
    enumerable: true,
    configurable: true
  });

  RemoteContainer.prototype.start = function () {
    var _this = this;

    return new Promise(function (resolve) {
      _this.setLastUsed();

      _this.observer.emit(Lifecycle.Connecting);

      if (_this.socket.connected) return resolve();

      _this.socket.emit("init", _this.capsuleType, _this.bitId);

      _this.socket.on("disconnect", function () {
        console.log("disconnected");
        _this.connected = false;
        _this._state = Lifecycle.Disconnected;

        _this.observer.emit(Lifecycle.Disconnected);
      });

      _this.socket.on("ready", function () {
        _this._state = Lifecycle.Connected;
        console.log("container ready");
      });

      _this.socket.on("devReady", function (_a) {
        var url = _a.url;
        _this.idle = false;
        _this.connected = true;
        _this._url = url;
        _this._state = Lifecycle.Connected;

        _this.observer.emit(Lifecycle.Connected, {
          url: url
        });

        resolve();
      });

      _this.socket.on("reconnect", function () {
        _this._state = Lifecycle.Reconnecting;

        _this.observer.emit(Lifecycle.Reconnecting);
      });

      _this.socket = _this.socket.connect();
    });
  };

  RemoteContainer.prototype.on = function (event, fn) {
    this.observer.register(event, fn);
  };

  RemoteContainer.prototype.setLastUsed = function () {
    this.lastUsed = Date.now();
  };

  RemoteContainer.prototype.log = function () {
    return __awaiter(this, void 0, void 0, function () {
      var sessionId, remoteExec;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.setLastUsed();
            return [4, new Promise(function (resolve, reject) {
              _this.socket.emit('log', function (_a) {
                var sessionId = _a.sessionId;
                return resolve(sessionId);
              });
            })];

          case 1:
            sessionId = _a.sent();
            remoteExec = new remote_exec_1.RemoteExec(sessionId, this.socket);
            this.socket.on("log." + sessionId + ".stdout", function (data) {
              remoteExec.stdout.write(new Uint8Array(data));
            });
            this.socket.on("log." + sessionId + ".stderr", function (data) {
              remoteExec.stderr.write(data);
            });
            return [2, Promise.resolve(remoteExec)];
        }
      });
    });
  };

  RemoteContainer.prototype.exec = function (options) {
    return __awaiter(this, void 0, void 0, function () {
      var sessionId, remoteExec;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, new Promise(function (resolve) {
              _this.socket.emit('exec', options, function (_a) {
                var sessionId = _a.sessionId;
                return resolve(sessionId);
              });
            })];

          case 1:
            sessionId = _a.sent();
            remoteExec = new remote_exec_1.RemoteExec(sessionId, this.socket);
            remoteExec.stdin.on('data', function (data) {
              _this.setLastUsed();

              _this.socket.emit("exec." + remoteExec.sessionId + ".stdin", data);
            });
            this.socket.on("exec." + remoteExec.sessionId + ".done", function (status) {
              remoteExec.setStatus(status);
            });
            this.socket.on("exec." + remoteExec.sessionId + ".stdout", function (data) {
              remoteExec.stdout.write(new Uint8Array(data));
            });
            this.socket.on("exec." + remoteExec.sessionId + ".stderr", function (data) {
              remoteExec.stderr.write(new Uint8Array(data));
            });
            return [2, remoteExec];
        }
      });
    });
  };

  RemoteContainer.prototype.get = function (path) {
    var _this = this;

    this.setLastUsed();
    return new Promise(function (resolve, reject) {
      _this.socket.on("fs.get.done", function (data) {
        resolve(data);
      });

      _this.socket.emit("fs.get", [path]);
    });
  };

  RemoteContainer.prototype.put = function (files, options) {
    var _this = this;

    this.setLastUsed();
    return new Promise(function (resolve, reject) {
      _this.socket.on("fs.writeFile.done", function (data) {
        resolve(data);
      });

      _this.socket.emit("fs.writeFile", files);
    });
  };

  RemoteContainer.prototype.writeFile = function (file, content) {
    var _this = this;

    this.setLastUsed();
    return new Promise(function (resolve, reject) {
      var id = v4_1.default();

      _this.socket.once("fs.writeFile." + id + ".done", function () {
        resolve();
      });

      _this.socket.once("fs.writeFile." + id + ".err", function (err) {
        reject(err);
      });

      _this.socket.emit("fs.writeFile", {
        id: id,
        args: [file, content]
      });
    });
  };

  RemoteContainer.prototype.inspect = function () {
    return Promise.resolve({
      ports: [],
      host: "localhost"
    });
  };

  RemoteContainer.prototype.pause = function () {
    this.socket.emit("pause", {});
    return Promise.resolve();
  };

  RemoteContainer.prototype.resume = function () {
    this.socket.connect();
    return this.start();
  };

  RemoteContainer.prototype.stop = function (ttl) {
    this.socket.emit("stop");
    this.destroy();
    return Promise.resolve();
  };

  RemoteContainer.prototype.destroy = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this._url = undefined;
            this._state = Lifecycle.Disconnected;
            return [4, this.socket.disconnect()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  RemoteContainer.prototype.mkdir = function (path, options) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var id = v4_1.default();

      _this.socket.once("fs.mkdir." + id + ".done", function () {
        resolve();
      });

      _this.socket.once("fs.mkdir." + id + ".error", function (err) {
        reject(err);
      });

      _this.socket.emit("fs.mkdir", {
        id: id,
        args: [path, options]
      });
    });
  };

  RemoteContainer.prototype.move = function (source, dest) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var id = v4_1.default();

      _this.socket.once("fs.move." + id + ".done", function () {
        return resolve();
      });

      _this.socket.once("fs.move." + id + ".error", function (err) {
        return reject(err);
      });

      _this.socket.emit("fs.move", {
        id: id,
        args: [source, dest]
      });
    });
  };

  RemoteContainer.prototype.readdir = function (path) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var id = v4_1.default();

      _this.socket.once("fs.readdir." + id + ".done", function (data) {
        resolve(data);
      });

      _this.socket.once("fs.readdir." + id + ".error", function (err) {
        reject(err);
      });

      _this.socket.emit("fs.readdir", {
        id: id,
        args: [path]
      });
    });
  };

  RemoteContainer.prototype.remove = function (path) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var id = v4_1.default();

      _this.socket.once("fs.unlink." + id + ".done", function () {
        resolve();
      });

      _this.socket.once("fs.unlink." + id + ".error", function (err) {
        reject(err);
      });

      _this.socket.emit("fs.unlink", {
        id: id,
        args: [path]
      });
    });
  };

  RemoteContainer.prototype.readFile = function (path) {
    var _this = this;

    this.setLastUsed();
    return new Promise(function (resolve, reject) {
      var id = v4_1.default();

      _this.socket.once("fs.readFile." + id + ".done", function (data) {
        resolve(data);
      });

      _this.socket.once("fs.readFile." + id + ".error", function (err) {
        reject(err);
      });

      _this.socket.emit("fs.readFile", {
        id: id,
        args: [path]
      });
    });
  };

  RemoteContainer.prototype.download = function (options) {
    var _this = this;

    this.setLastUsed();
    return new Promise(function (resolve, reject) {
      var id = v4_1.default();

      _this.socket.once("download." + id + ".done", function (data) {
        resolve(data);
      });

      _this.socket.once("download." + id + ".error", function (err) {
        reject(err);
      });

      _this.socket.emit("download", Object.assign(id, options));
    });
  };

  RemoteContainer.prototype.access = function (path, mode) {
    var _this = this;

    this.setLastUsed();
    return new Promise(function (resolve, reject) {
      var id = v4_1.default();

      _this.socket.once("fs.access." + id + ".done", function (data) {
        resolve(data);
      });

      _this.socket.once("fs.access." + id + ".error", function (err) {
        reject(err);
      });

      _this.socket.emit("fs.access", {
        id: id,
        args: [path, mode]
      });
    });
  };

  return RemoteContainer;
}();

exports.default = RemoteContainer;